import fitvids from 'fitvids';

export default class RTE {
  constructor() {
    fitvids('.rte');
  }
}
